import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import Select from 'react-select';
import SchedulesElaborateBases from './Elements/SchedulesElaborateBases';
import SchedulesElaborateExpirations from './Elements/SchedulesElaborateExpirations';
import SchedulesElaborateRotations from './Elements/SchedulesElaborateRotations';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class SchedulesIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      view_bases: [],
      total_ano: [],
      schedule: [],
      aircraft_models_list: [],
      certifications_list: [],
      month: '',
      year: '',
      show_bases: 0,
      show_expirations: 0,
      show_rotations: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.elaborateClean = this.elaborateClean.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      var now = new Date();
      var month = (now.getMonth()) + 2;
      var year = now.getFullYear();
      this.setState({year: year, month: month, loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/elaboracao';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
           aircraft_models_list: responseJson.data,
         });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
     });
    });
  }
  elaborateClean(event) {
    if (typeof this.state.month === 'undefined' || this.state.month === null || this.state.month === '' || typeof this.state.year === 'undefined' || this.state.year === null || this.state.year === '' || typeof this.state.aircraft_model_id === 'undefined' || this.state.aircraft_model_id === null || this.state.aircraft_model_id === '') {
      this.handleAlert(this.locale.Escalas.ElaboracaoDeEscala.todosOsCamposDoFormularioDevemSerPreenchdios, 'error', 'open');
      event.preventDefault();
    } else {
      event.preventDefault();
      this.setState({show_bases: 0});
      this.setState({show_expirations: 0});
      this.setState({show_rotations: 0});
      this.elaborate(event);
    }
  }

  elaborate(event) {
    this.handleAlert('', '', 'open');
    var datasave = {
      month: this.state.month,
      year: this.state.year,
      aircraft_model_id: this.state.aircraft_model_id,
      action: event.currentTarget.value,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/elaboracao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          if (responseJson.action === 'bases') {
           self.setState({view_bases: responseJson.data});
           self.setState({total_ano: responseJson.total_ano.staffs});
           self.setState({schedule: responseJson.schedule});
           self.setState({show_bases: 1});
          } else if(responseJson.action === 'expirations') {
           self.setState({certifications_list: responseJson.certifications_list});
           self.setState({schedule: responseJson.schedule});
           self.setState({show_expirations: 1});
          } else if(responseJson.action === 'rotations') {
           self.setState({schedule: responseJson.schedule});
           self.setState({tripulante: responseJson.tripulante});
           self.setState({sugestoes: responseJson.sugestoes});
           self.setState({today: responseJson.today});
           self.setState({data_inicial_90: responseJson.data_inicial_90});
           self.setState({show_rotations: 1});
          }
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <form>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.Escalas.ElaboracaoDeEscala.formulario.Mes}:</label>
            <input type="text" className="form-control" name="month" value={this.state.month} onChange={this.handleChange.bind(this, 'month')} required />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.Escalas.ElaboracaoDeEscala.formulario.Ano}:</label>
            <input type="text" className="form-control" name="year" value={this.state.year} onChange={this.handleChange.bind(this, 'year')} required />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.Escalas.ElaboracaoDeEscala.formulario.Frota}:</label>
            <Select
              className="form-field-name"
              name="aircraft_model_id"
              value={this.state.aircraft_model_id}
              searchable={true}
              placeholder={this.locale.Escalas.ElaboracaoDeEscala.formulario.placeholder.SelecionarFrota}
              onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
              options={this.state.aircraft_models_list}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
                <button onClick={this.elaborateClean} className="btn btn-success btn-block" value={1}><i className="fa fa-file-o fa-fw"></i> {this.locale.Escalas.ElaboracaoDeEscala.formulario.botaoBases}</button>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <button onClick={this.elaborateClean} className="btn btn-success btn-block" value={2}><i className="fa fa-file-o fa-fw"></i> {this.locale.Escalas.ElaboracaoDeEscala.formulario.botaoRodizio}</button>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <button onClick={this.elaborateClean} className="btn btn-success btn-block" value={3}><i className="fa fa-file-o fa-fw"></i> {this.locale.Escalas.ElaboracaoDeEscala.formulario.botaoVencimentos}</button>
            </div>
          </div>
        </div>
      </form>
      <hr/>
      <SchedulesElaborateBases RequestApi={this.refs.request_api} show={this.state.show_bases} handleAlert={this.handleAlert} data={this.state.view_bases} total_ano={this.state.total_ano} schedule={this.state.schedule} />
      <SchedulesElaborateRotations show={this.state.show_rotations} today={this.state.today} tripulante={this.state.tripulante} sugestoes={this.state.sugestoes} data_inicial_90={this.state.data_inicial_90} schedule={this.state.schedule} />
      <SchedulesElaborateExpirations RequestApi={this.refs.request_api} show={this.state.show_expirations} handleAlert={this.handleAlert} aircraft_model_id={this.state.aircraft_model_id} month={this.state.month} year={this.state.year} certifications_list={this.state.certifications_list} schedule={this.state.schedule} />
    </div>
  </div>
</div>
    );
  }
}

export default SchedulesIndex;



// WEBPACK FOOTER //
// ./src/Components/Schedules/SchedulesElaborate.js